var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 37.9285V29.3985H50.6338V37.9293M36.0014 25.5293V37.8431",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0012 25.5293C40.555 25.5293 44.2466 21.8378 44.2466 17.284C44.2466 12.7302 40.555 9.03857 36.0012 9.03857C31.4474 9.03857 27.7559 12.7302 27.7559 17.284C27.7559 21.8378 31.4474 25.5293 36.0012 25.5293Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3516 23.273C31.6539 21.5792 33.6977 20.4807 36.0046 20.4807C38.3116 20.4807 40.3716 21.5792 41.6485 23.2899",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 17.2838C37.2645 17.2838 38.2894 16.2589 38.2894 14.9946C38.2894 13.7302 37.2645 12.7053 36.0002 12.7053C34.7359 12.7053 33.7109 13.7302 33.7109 14.9946C33.7109 16.2589 34.7359 17.2838 36.0002 17.2838Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6173 37.9285H54.6496V45.9615H46.6173V37.9285ZM31.9835 37.9285H40.015V45.9615H31.9842L31.9835 37.9285ZM17.3496 37.9285H25.3819V45.9615H17.3496V37.9285Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 37.9285V29.3985H50.6338V37.9293M36.0014 25.5293V37.8431",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0012 25.5293C40.555 25.5293 44.2466 21.8378 44.2466 17.284C44.2466 12.7302 40.555 9.03857 36.0012 9.03857C31.4474 9.03857 27.7559 12.7302 27.7559 17.284C27.7559 21.8378 31.4474 25.5293 36.0012 25.5293Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3516 23.2733C31.6539 21.5794 33.6977 20.481 36.0046 20.481C38.3116 20.481 40.3716 21.5794 41.6485 23.2902",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9992 17.284C37.2635 17.284 38.2884 16.2591 38.2884 14.9948C38.2884 13.7305 37.2635 12.7056 35.9992 12.7056C34.7349 12.7056 33.71 13.7305 33.71 14.9948C33.71 16.2591 34.7349 17.284 35.9992 17.284Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6173 37.9285H54.6496V45.9615H46.6173V37.9285ZM31.9835 37.9285H40.015V45.9615H31.9842L31.9835 37.9285ZM17.3496 37.9285H25.3819V45.9615H17.3496V37.9285Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1591 57.1364C23.1591 58.0767 22.983 58.8821 22.6307 59.5526C22.2813 60.2202 21.804 60.7315 21.1989 61.0866C20.5966 61.4418 19.9134 61.6193 19.1491 61.6193C18.3849 61.6193 17.7003 61.4418 17.0952 61.0866C16.4929 60.7287 16.0156 60.2159 15.6634 59.5483C15.3139 58.8778 15.1392 58.0739 15.1392 57.1364C15.1392 56.196 15.3139 55.392 15.6634 54.7244C16.0156 54.054 16.4929 53.5412 17.0952 53.1861C17.7003 52.831 18.3849 52.6534 19.1491 52.6534C19.9134 52.6534 20.5966 52.831 21.1989 53.1861C21.804 53.5412 22.2813 54.054 22.6307 54.7244C22.983 55.392 23.1591 56.196 23.1591 57.1364ZM21.5696 57.1364C21.5696 56.4744 21.4659 55.9162 21.2585 55.4616C21.054 55.0043 20.7699 54.6591 20.4062 54.4261C20.0426 54.1903 19.6236 54.0724 19.1491 54.0724C18.6747 54.0724 18.2557 54.1903 17.892 54.4261C17.5284 54.6591 17.2429 55.0043 17.0355 55.4616C16.831 55.9162 16.7287 56.4744 16.7287 57.1364C16.7287 57.7983 16.831 58.358 17.0355 58.8153C17.2429 59.2699 17.5284 59.6151 17.892 59.8509C18.2557 60.0838 18.6747 60.2003 19.1491 60.2003C19.6236 60.2003 20.0426 60.0838 20.4062 59.8509C20.7699 59.6151 21.054 59.2699 21.2585 58.8153C21.4659 58.358 21.5696 57.7983 21.5696 57.1364ZM24.6538 61.5V52.7727H30.2447V54.098H26.2347V56.4673H29.8612V57.7926H26.2347V61.5H24.6538ZM31.685 61.5V52.7727H37.2759V54.098H33.266V56.4673H36.8924V57.7926H33.266V61.5H31.685ZM40.2972 52.7727V61.5H38.7163V52.7727H40.2972ZM49.4794 55.7173H47.8857C47.8402 55.456 47.7564 55.2244 47.6342 55.0227C47.5121 54.8182 47.3601 54.6449 47.1783 54.5028C46.9964 54.3608 46.7891 54.2543 46.5561 54.1832C46.326 54.1094 46.0774 54.0724 45.8104 54.0724C45.3359 54.0724 44.9155 54.1918 44.549 54.4304C44.1825 54.6662 43.8956 55.0128 43.6882 55.4702C43.4808 55.9247 43.3771 56.4801 43.3771 57.1364C43.3771 57.804 43.4808 58.3665 43.6882 58.8239C43.8984 59.2784 44.1854 59.6222 44.549 59.8551C44.9155 60.0852 45.3345 60.2003 45.8061 60.2003C46.0675 60.2003 46.3118 60.1662 46.5391 60.098C46.7692 60.027 46.9751 59.9233 47.157 59.7869C47.3416 59.6506 47.4964 59.483 47.6214 59.2841C47.7493 59.0852 47.8374 58.858 47.8857 58.6023L49.4794 58.6108C49.4197 59.0256 49.2905 59.4148 49.0916 59.7784C48.8956 60.142 48.6385 60.4631 48.3203 60.7415C48.0021 61.017 47.63 61.233 47.2038 61.3892C46.7777 61.5426 46.3047 61.6193 45.7848 61.6193C45.0178 61.6193 44.3331 61.4418 43.7308 61.0866C43.1286 60.7315 42.6541 60.2188 42.3075 59.5483C41.9609 58.8778 41.7876 58.0739 41.7876 57.1364C41.7876 56.196 41.9624 55.392 42.3118 54.7244C42.6612 54.054 43.1371 53.5412 43.7393 53.1861C44.3416 52.831 45.0234 52.6534 45.7848 52.6534C46.2706 52.6534 46.7223 52.7216 47.1399 52.858C47.5575 52.9943 47.9297 53.1946 48.2564 53.4588C48.5831 53.7202 48.8516 54.0412 49.0618 54.4219C49.2749 54.7997 49.4141 55.2315 49.4794 55.7173ZM50.9272 61.5V52.7727H56.6033V54.098H52.5082V56.4673H56.3093V57.7926H52.5082V60.1747H56.6374V61.5H50.9272Z",
    fill: "#2F49D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 71.5,
    height: 71.5,
    rx: 4.75,
    stroke: "#2F49D1",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressOne);
export default __webpack_public_path__ + "static/media/AddressOne.9e0cb0db571e19df0fe8ae9fd8b05351.svg";
export { ForwardRef as ReactComponent };